/*
 * @Descripttion:
 * @Date: 2024-08-06 10:12:42
 */
import http from '@/utils/http/axios';
import type {
  ZonesList,
  RelationProject,
  SubmitDetail,
  PromotionContent
} from './types';
import { ContentTypeEnum } from '@/utils/http/axios/enums';

enum Api {
  zonesList = '/front-end/zm/api/v1/zones', // 专区列表
  delZone = '/front-end/zm/api/v1/delZone', // 专区列表删除

  relationProject = '/front-end/zm/api/v1/relationProject', // 关联项目列表

  zoneDetail = '/front-end/zm/api/v1/zoneDetail', // 专区详情
  addOrUpdate = '/front-end/zm/api/v1/addOrUpdate', // 新增编辑专区
  zoneRelationInfo = '/front-end/zm/api/v1/zoneRelationInfo', // 专区关联资讯列表
  removeRelationInfo = '/front-end/zm/api/v1/removeRelationInfo', // 专区关联资讯列表 - 移除操作
  changeRelationStatus = '/front-end/zm/api/v1/changeRelationStatus', // 专区详情 - 资讯状态变更
  submitDetail = '/front-end/zm/api/v1/submitDetail', // 专区详情 - 资讯任务量-提交详情
  promotionContent = '/front-end/zm/api/v1/infos', // 选择推广内容

  checkInfoStatus = '/front-end/zm/api/v1/checkInfoStatus' //检查资讯状态
}

export const zonesList: ZonesList = params =>
  http.request({
    url: Api.zonesList,
    method: 'POST',
    params
  });

export const relationProject: RelationProject = params =>
  http.request({
    url: Api.relationProject,
    method: 'POST',
    params
  });

export const promotionContent: PromotionContent = params =>
  http.request({
    url: Api.promotionContent,
    method: 'POST',
    params
  });
export const submitDetail: SubmitDetail = params =>
  http.request({
    url: Api.submitDetail,
    method: 'POST',
    params
  });
export const delZone = async (params: {
  id: number;
  hasForm: number;
}): Promise<Result<{}>> =>
  http.request(
    {
      url: Api.delZone,
      method: 'POST',
      params
    },
    {
      isParseToJson: false,
      headers: { 'content-type': ContentTypeEnum['FORM_URLENCODED'] }
    }
  );
export const zoneDetail = async (params: {
  id: number;
  hasForm: number;
}): Promise<
  Result<{
    id?: number; //专区id
    title: string; //专区名称
    sortMode: number;
    mobileShowMode: number;
    banners: {
      //专区封面图及跳转url ,ZoneBanner
      imgUrl: string; //图片url
      title: string; //资讯名称
      id: number; //资讯 id
    }[];
    relationships: {
      relationId: number; //专区资讯关联表id
      id: number; //资讯id
      infoCode: string; //资讯编号ID
      title: string; //资讯名称
      author: string; //资讯作者
      surveyCode: string; //表单编号
      taskNum: number; //任务提交量
      visible: number; //资讯状态是否展示0隐藏1显示
      weight: number; //排序
    }[];
  }>
> =>
  http.request({
    url: Api.zoneDetail,
    method: 'GET',
    params
  });

export const zoneRelationInfo = async (params: {
  id: number;
  hasForm: number;
}): Promise<
  Result<
    {
      relationId: number; //专区资讯关联表id
      id: number; //资讯id
      infoCode: string; //资讯编号ID
      title: string; //资讯名称
      author: string; //资讯作者
      surveyCode: string; //表单编号
      taskNum: number; //任务提交量
      visible: number; //资讯状态 是否展示 0隐藏 1  显示
    }[]
  >
> =>
  http.request({
    url: Api.zoneRelationInfo,
    method: 'GET',
    params
  });
export const removeRelationInfo = async (params: {
  relationId: number;
  hasForm: number;
}): Promise<Result<{}>> =>
  http.request({
    url: Api.removeRelationInfo,
    method: 'POST',
    params
  });

export const checkInfoStatus = async (params: {
  infoId: number;
  hasForm: number;
  status: number;
}): Promise<Result<{}>> =>
  http.request({
    url: Api.checkInfoStatus,
    method: 'GET',
    params
  });

export const addOrUpdate = async (params: {
  id?: number;
  title: string;
  hasForm: number;
  sortMode: number; //排序方式   1 手动设置  2 自动倒序
  mobileShowMode: number; //移动端展示样式  1 平铺显示 2 折叠显示
  banners: {
    imgUrl: string; //图片url
    title: string; //资讯名称
    id: number; //资讯 id
  }[];
  relationships: {
    id: string; //资讯id
    visible: string; //是否展示 0隐藏 1  显示
    weight: number; //排序字段
  }[];
}): Promise<Result<{}>> =>
  http.request({
    url: Api.addOrUpdate,
    method: 'POST',
    params
  });
